export default {
  user: sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : {},
  orderType: '',
  loading: false
};



// WEBPACK FOOTER //
// ./src/store/base/state.js